import { Locale } from '~/locale/types';

export const defaultLocale = 'en' as Locale;

export const locales = ['en', 'fr'] as Locale[];
